import React, { useState, useEffect } from 'react';
import { useParams,useHistory } from "react-router-dom";
import toast from 'toasted-notes'
import 'toasted-notes/src/styles.css';
import CrudForm from "../../../crud/CrudForm"
import {ivatypeService as service } from "../../../../services"
import { useTranslation } from 'react-i18next';


  const initElement =  {
    name : null,
    recagoPercent:null,
    percent:null
};


export default function FormIva() {
  const { t, i18n } = useTranslation();


  const estructureform =  [
      {
        type:"input",
        name: "name",
        col: 4
       },
       {
         type:"input",
         name: "percent",
         inputtype: "number",
         col: 4
        },
        {
          type:"input",
          name: "recagoPercent",
          inputtype: "number",
          col: 4
         },
   ];


  const recoveryElement = function(objectedit,element){


    objectedit['name']=element.name?element.name:"";
    objectedit['percent']=element.percent?element.percent:0.0;
    objectedit['recagoPercent']=element.recagoPercent?element.recagoPercent:0.0;

    

    return objectedit;
  }



  const isValid = function(object){
      if(!object['name']){
        return t("ivatype.error.name");
      }
      if(!object['percent']){
        return t("ivatype.error.percent");
      }
      if(!object['recagoPercent']){
        return t("ivatype.error.recagoPercent");
      }
      
      return null;
  }



  return (
    <CrudForm
        objectform = {{...initElement}}
        estructureform = {estructureform}
        i18n={"ivatype"}
        urledit={"/ivatype/edit/"}
        urlCancel={"/ivatype"}
        service = {service}
        recoveryElement = {recoveryElement}
        valid = {isValid}
      />

  );
}
